import React from 'react';
import { TextField, InputAdornment } from '@mui/material';
import { AttachMoneyOutlined } from '@mui/icons-material';
import { useCostEditor } from '../../../../hooks/useCostEditor';

/**
 * VendorCostEditor - Currency input for vendor/contractor cost.
 */
export const VendorCostEditor: React.FC = () => {
  const { costRecord, updateCostField } = useCostEditor();

  const handleChange = (value: string) => {
    const parsed = value === '' ? undefined : parseFloat(value);
    updateCostField({ vendorCost: parsed });
  };

  return (
    <TextField
      label="Vendor Cost"
      type="number"
      value={costRecord?.vendorCost ?? ''}
      onChange={(e) => handleChange(e.target.value)}
      size="small"
      fullWidth
      placeholder="0.00"
      inputProps={{ min: 0, step: 0.01 }}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <AttachMoneyOutlined sx={{ color: '#64748b', fontSize: 18 }} />
          </InputAdornment>
        ),
      }}
    />
  );
};

export default VendorCostEditor;
